export default __webpack_public_path__ + "static/media/bg_groupement_pres-2.125a4bdb.jpg";